import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { User } from '../../gen/model/user';
import { Logger } from '../../util/logger';
import { StandaloneComponent } from '../standalone.component';
import {CountriesService} from '../countries-service';
import {Observable, Subscription} from 'rxjs';
import {AuthenticationInfoService} from '../authentication-info.service';
import {AppComponent} from '../app.component';
import {TranslateService} from '@ngx-translate/core';
import {AppConstants} from '../AppConstants';


const _ = (s) => s;


@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ViewProfileComponent extends StandaloneComponent implements OnInit {

  profile: User;
  private navigationEndSubscription: Subscription;
  constructor(
    protected authenticationInfoService: AuthenticationInfoService,
    route: ActivatedRoute,
    router: Router,
    protected countries: CountriesService,
    protected logger: Logger,
    protected translate: TranslateService,
    hostElement: ElementRef) {
  super(route, router, hostElement);
    this.focusSelectorPrefix = '.card-body';
  }
  resolveCountryName(code: string): Observable<string> {
    return this.countries.getCountryName(code);
  }
  onProfileLoaded(user: User) {
    this.profile = user;
  }
  ngOnInit() {
    super.init();
    this.authenticationInfoService.getUser().subscribe((resp) => {
        this.authenticationInfoService.getProfileSubscription().subscribe(response => { this.onProfileLoaded(response); });
      }, (err) => {
        this.authenticationInfoService.getProfileSubscription().subscribe(response => { this.onProfileLoaded(response); });
    });

    this.navigationEndSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        StandaloneComponent.setFocusToElemOrChildControl(this.hostElement, this.focusSelectorPrefix);
      }
    });
  }
  signOut() {
    this.router.navigate([AppConstants.PATH_LOGOUT], {
      relativeTo: this.route,
    });
  }

  resolveDisplayName(): string|any {
    // we should never be here with a partial session
    return AppComponent.resolveUserName(this.profile, this.translate, false);
  }
  /**
   * Adds <wbr /> tags for each non alphanumeric character
   * @param {string} val
   * @returns {string}
   */
  addWordBreaks(val: string): string {
    return val ? val.replace(/(\W)/g, '<wbr />$1') : val;
  }

  public resolveWindowTitlePart(): Observable<string|undefined> {
    return this.translate.get(_('view-profile.window-title'));
  }
}
